'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.apps.list', [])
  .controller('AppsListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/apps/list/index.js